module.exports = __webpack_public_path__ + "static/media/OCFL-Atlas-App-Page.9c152082.png";